"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSticky = useSticky;
var _react = require("react");
/**
 * Holds a transient value so that it is non-nullish, making it "stick" to its last non-nullish value. The hook can
 * still return null or undefined if the initial value was such, but once a non-nullish value is set, it will never
 * return null or undefined again.
 * @param value The value to hold.
 * @returns Returns `value` if it is non-nullish, otherwise returns the last `value` that was non-nullish. If no
 * previous value meets that criteria, returns `value`.
 */
function useSticky(value) {
  const [valueSticky, setValueSticky] = (0, _react.useState)(value);
  (0, _react.useEffect)(() => {
    if (value !== undefined && value !== null) {
      setValueSticky(value);
    }
  }, [value]);
  return valueSticky;
}